<template>
  <div class="wDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul class="users">
      <li>
        <span>用户头像</span>
        <img :src="userData.avatar" />
      </li>
      <li>
        <span>用户昵称</span>
        <font>{{userData.username}}</font>
      </li>
      <li>
        <span>手机号</span>
        <font>{{userData.phone}}</font>
      </li>
    </ul>

    <div class="code" @click="getQquey">
      <img src="~assets/images/ScanTicket.png" >
      <p>点击一下上图，出现扫码框后扫实体卡的二维码后<font>点击领取</font></p>
    </div>

    <div class="scenic commen" v-if="setMall.length > 0">
      <h2>
        <div class="ctitle">推荐商圈<a @click="$router.push('product?sp=1')">更多<i class="el-icon-arrow-right"></i></a></div>
      </h2>
      <ul>
        <li v-for="(item,i) in setMall" @click="toPush(item.id,'detail')">
          <div class="title">
            <img :src="baseUrl+item.logo" >
            <div class="conTitle">
              <span>{{item.title}}</span>
              <font>营业时间：{{item.business}}</font>
              <div class="price">星级<i>{{item.star}}</i> 月售:{{item.sale}}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setMall:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getMall();
      
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'scanQRCode'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['scanQRCode'],
              success: function (res) {
                if (res.checkResult.scanQRCode === true) {
                  wx.scanQRCode({
                    desc: 'scanQRCode desc',
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {

                        window.location.href = 'http://user.4008005216.com/main/cash?id='+res.resultStr
                      
                    }, 
                    fail : function(res) { 
                      console.log(res)
                    } 
                  });
                }else {
                  alert('抱歉，当前客户端版本不支持扫一扫')
                }
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      getMall:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/index/scenicMall'
        }).then(function(response){
          var res = response.data;
          that.setMall = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .wDetailApp{
    max-width:640px;
    background:#f1f1f1;
    margin:0 auto;
  }
  .wDetailApp .users{
    background:#fff;
  }
  .wDetailApp .users li{
    display:block;
    width:92%;
    margin:0 auto;
    height:50px;
    border-bottom:solid 1px #f1f1f1;
    line-height:50px;
    font-size:15px;
  }
  .wDetailApp .users li font{
    float:right
  }
  .wDetailApp .users li img{
    float:right;
    width:40px;
    border-radius:50%;
    margin-top:5px
  }
  .wDetailApp .code{
    background:#fff;
    width:100%;
    display:block;
    padding:50px 0;
    margin-top:8px
  }
  .wDetailApp .code img{
    display:block;
    width:40%;
    margin:0 auto
  }
  .wDetailApp .code p{
    font-size:14px;
    text-align:center;
    padding-top:20px;
    color:#666;
    width:65%;
    margin:0 auto;
    line-height:22px
  }
  .wDetailApp .code p font{
    color:#f00;
    font-weight:bold;
    padding-left:5px
  }



  .wDetailApp .commen{
    background:#fff;
    width:100%;
    margin-top:10px
  }
  .wDetailApp .commen h2{
    margin:0 auto;
    font-size:16px;
    padding:15px 0;
    border-bottom:solid 1px #f5f5f5;
  }
  .wDetailApp .commen h2 .ctitle{
    width:89%;
    margin:0 auto;
    position:relative;
    padding-left:3%;
  }
  .wDetailApp .commen h2 .ctitle:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:4px;
    border-radius: 3px;
  }
  .wDetailApp .commen h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666;
    margin-top:2px
  }
  .wDetailApp .scenic ul li{
    width:92%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #f5f5f5;
    padding-bottom:15px
  }
  .wDetailApp .scenic ul li .title{
    position:relative;
    width:100%;
  }
  .wDetailApp .scenic ul li .title img{
    float:left;
    width:30%;
    border-radius:6px;
  }
  .wDetailApp .scenic ul li .title .conTitle{
    float:left;
    width:67%;
    margin-left:3%;
  }
  .wDetailApp .scenic ul li .title .conTitle span{
    display:block;
    color:#333333;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    font-size:15px;
    font-weight: bold;
  }
  .wDetailApp .scenic li .title .conTitle font{
    display:block;
    color:#666;
    font-size:14px;
    padding:10px 0
  }
  .wDetailApp .scenic li .title .conTitle .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .wDetailApp .scenic li .title .conTitle .price b{
    font-size:12px;
  }

  .wDetailApp .scenic li .title .conTitle .price{
    font-size: 14px;
    font-family: PingFang SC;
    color: #666;
  }
  .wDetailApp .commen ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
</style>